<template>
  <div class="cover flex-c">
    <div class="w30 h20 bg-color-white r10 t-c" @keydown="keydown_event($event)" ref="auth_box" tabindex="0" :class="{shaking:err}">
        <div class="col-12 h17 pt10">
            <div class="mt20 mb20"><i class="iconfont icon-warning-filling f50 color-warning"></i></div>
            <div class="color2 mt10 pl10 pr10">{{$store.state.confim_box.msg}}</div>
            <div class="col-12" v-if="$store.state.confim_box.type == 'check_password'">
              <input type="text" class="w20 bg-color1 h4 lh40 r5 t-c b1">
            </div>
        </div>
        <div class="col-12">
          <button class="fl bg-color-danger lh35 w15 color-white rbl10" @click="keydown_event(13)" v-if="$store.state.confim_box.type == 'confim_del' || $store.state.confim_box.type == 'confim_auto' || $store.state.confim_box.type == 'pago_exit'">
            <span class="f14">[Entra].Si</span>
          </button>
          <button class="fl bg-color-primary lh35 w15 color-white rbl10" @click="keydown_event(13)" v-if="$store.state.confim_box.type == 'confim_exit'"><span class="f14">[Entra].Si</span></button>
          <button class="fl bg-color-primary lh35 w30 color-white rbl10 rbr10" @click="keydown_event(27)" v-if="$store.state.confim_box.type == 'confim_esc'"><span class="f14">[ESC].Si</span></button>
          <button class="fl bg-color-muted lh35 w15 color-white rbr10" @click="keydown_event(27)" v-if="$store.state.confim_box.type != 'confim_esc'"><span class="f14">[ESC].No</span></button>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ConfimBox',
  data () {
    return {
      err: false,
      timer1: ''
    }
  },
  created: function () {
    switch (this.$store.state.confim_box.type) {
      case 'confim_esc':
        this.$store.commit('setSound',true)
        this.err = true
        break;
      case 'confim_auto':
        this.timer1 = setTimeout(() => {
          this.keydown_event(27)
        }, 3000);
        break;
    }

    setTimeout(() => {
      this.$refs['auth_box'].focus();
    }, 50);
  },
  methods: {
    keydown_event(event) {
      if(this.timer1){
        clearTimeout(this.timer1);
      }
      if (typeof (event) == "number") {
        var keyCode = event;
      }
      else {
        var keyCode = event.keyCode;
      }
      switch (keyCode) {
        //ESC
        case 27:
          let focus = this.$store.state.confim_box.focus
          if(this.$store.state.pay){
            focus = 'pay'
          }
          this.$store.commit('setConfimBox',{type:'',_this:this.$store.state.confim_box._this,focus:focus})
          break;
        //回车
        case 13:
          switch (this.$store.state.confim_box.type) {
            case 'confim_exit':
            case 'pago_exit':
              this.$store.commit('setConfimBox',{type:'',_this:this.$store.state.confim_box._this,method:this.$store.state.confim_box.method,arg1:this.$store.state.confim_box.arg1,arg2:this.$store.state.confim_box.arg2,check:true})
              break;
            case 'confim_auto':
              this.$store.commit('setConfimBox',{type:'',_this:this.$store.state.confim_box._this,focus:'keyword'})
              break;
            case 'confim_esc':
              this.$store.commit('setSound',true)
              break;
            case 'confim_del':
              this.$store.commit('setConfimBox',{type:'',_this:this.$store.state.confim_box._this,method:this.$store.state.confim_box.method,arg1:this.$store.state.confim_box.arg1,arg2:this.$store.state.confim_box.arg2,check:true})
              break;
          }
          break;
      }
    },  
  }
}
</script>
<style scoped>
.cover div{
    outline:none;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfimBox.vue